<template>
  <div class="reg page-shell">
    <div class="app-container">
      <header class="reg__head" v-reveal>
        <span class="eyebrow">{{ $t('registration.eyebrow') }}</span>
        <h1 class="reg__title display-title">
          {{ $t('registration.titleA') }} <span class="text-flame">{{ $t('registration.titleB') }}</span> {{ $t('registration.titleC') }}
        </h1>
        <div v-if="tournament" class="reg__tournament-badge d-inline-flex align-items-center gap-2 mt-2 p-2 rounded-3">
          <img v-if="tournament.logo_url || tournament.logo" :src="tournament.logo_url || tournament.logo" alt="Logo Event" class="rounded-2 shadow-sm" style="width: 44px; height: 44px; object-fit: contain; background: #fff; padding: 2px;" />
          <p class="reg__tournament mb-0">
            <i class="bi bi-trophy-fill text-warning me-1" v-if="!tournament.logo_url && !tournament.logo" aria-hidden="true"></i>
            {{ tournament.name }}
          </p>
        </div>
      </header>

      <div class="reg__layout">
        <!-- ══════════════ KOLOM FORM ══════════════ -->
        <div class="reg__main">
          <!--
            Bilah langkah hanya muncul kalau memang ada lebih dari satu.
            Pendaftaran tanpa acara cuma butuh satu formulir; menampilkan
            penunjuk langkah berisi satu titik justru membuat pengguna
            mengira ada tahap berikutnya yang belum terlihat.
          -->
          <ol class="stepper" role="list" v-if="langkah.length > 1">
            <li
              v-for="(s, i) in langkah"
              :key="s.key"
              class="stepper__item"
              :class="{ 'is-active': i === stepAktif, 'is-done': i < stepAktif }"
            >
              <span class="stepper__dot">
                <i v-if="i < stepAktif" class="bi bi-check-lg" aria-hidden="true"></i>
                <span v-else>{{ i + 1 }}</span>
              </span>
              <span class="stepper__label">{{ $t(s.label) }}</span>
            </li>
          </ol>

          <form class="reg-card ui-card" novalidate @submit.prevent="lanjut">
            <div class="reg-card__body">
              <transition name="step" mode="out-in">
                <!-- ── LANGKAH 1: AKUN ── -->
                <div v-if="stepAktif === 0" key="akun" class="step-pane">
                  <h2 class="step-pane__title">{{ $t('registration.accountTitle') }}</h2>
                  <p class="step-pane__hint">
                    {{ $t('registration.accountHint') }}
                  </p>

                  <div class="ui-field">
                    <label for="pj" class="ui-label">{{ $t('registration.fullName') }}</label>
                    <input
                      id="pj"
                      v-model.trim="form.person_responsible"
                      type="text"
                      class="ui-input"
                      :placeholder="$t('registration.fullNamePlaceholder')"
                      autocomplete="name"
                      :aria-invalid="Boolean(errors.person_responsible)"
                    />
                    <p v-if="errors.person_responsible" class="ui-error">{{ errors.person_responsible }}</p>
                  </div>

                  <div class="ui-field">
                    <label for="email" class="ui-label">{{ $t('auth.email') }}</label>
                    <input
                      id="email"
                      v-model.trim="form.email"
                      type="email"
                      class="ui-input"
                      :placeholder="$t('auth.emailPlaceholder')"
                      autocomplete="email"
                      :aria-invalid="Boolean(errors.email)"
                    />
                    <p v-if="errors.email" class="ui-error">{{ errors.email }}</p>
                  </div>

                  <div class="reg__two-col">
                    <div class="ui-field">
                      <label for="pw" class="ui-label">{{ $t('auth.password') }}</label>
                      <div class="reg__pw">
                        <input
                          id="pw"
                          v-model="form.password"
                          :type="lihatSandi ? 'text' : 'password'"
                          class="ui-input"
                          :placeholder="$t('registration.passwordPlaceholder')"
                          autocomplete="new-password"
                          :aria-invalid="Boolean(errors.password)"
                        />
                        <button
                          type="button"
                          class="reg__pw-toggle"
                          :aria-label="lihatSandi ? $t('auth.hidePassword') : $t('auth.showPassword')"
                          @click="lihatSandi = !lihatSandi"
                        >
                          <i :class="lihatSandi ? 'bi bi-eye-slash' : 'bi bi-eye'" aria-hidden="true"></i>
                        </button>
                      </div>

                      <div v-if="form.password" class="pw-meter">
                        <span
                          v-for="n in 3"
                          :key="n"
                          class="pw-meter__bar"
                          :class="{ 'is-on': kekuatanSandi >= n }"
                          :data-level="kekuatanSandi"
                        ></span>
                        <span class="pw-meter__label">{{ labelKekuatan }}</span>
                      </div>

                      <p v-if="errors.password" class="ui-error">{{ errors.password }}</p>
                    </div>

                    <div class="ui-field">
                      <label for="pw2" class="ui-label">{{ $t('auth.passwordConfirm') }}</label>
                      <input
                        id="pw2"
                        v-model="form.password_confirmation"
                        :type="lihatSandi ? 'text' : 'password'"
                        class="ui-input"
                        :placeholder="$t('registration.passwordRepeat')"
                        autocomplete="new-password"
                        :aria-invalid="Boolean(errors.password_confirmation)"
                      />
                      <p v-if="errors.password_confirmation" class="ui-error">
                        {{ errors.password_confirmation }}
                      </p>
                    </div>
                  </div>
                </div>

                <!-- ── LANGKAH: VERIFIKASI EMAIL OTP ── -->
                <div v-else-if="isOtpStep" key="otp" class="step-pane text-center">
                  <div class="otp-icon-wrap mb-3">
                    <i class="bi bi-shield-lock-fill text-danger fs-1"></i>
                  </div>
                  <h2 class="step-pane__title text-center">{{ $t('registration.otpTitle') }}</h2>
                  <p class="step-pane__hint text-center">
                    {{ $t('registration.otpHint') }}<br />
                    <span class="otp-email-badge">
                      <i class="bi bi-envelope-check"></i>
                      <strong>{{ form.email }}</strong>
                      <button type="button" class="btn-link p-0 ms-2 border-0 bg-transparent text-primary fw-semibold" @click="stepAktif = 0">
                        ({{ $t('registration.changeEmail') }})
                      </button>
                    </span>
                  </p>

                  <div class="ui-field my-4" style="max-width: 320px; margin-inline: auto;">
                    <label for="otpInput" class="ui-label text-center d-block">{{ $t('registration.otpLabel') }}</label>
                    <input
                      id="otpInput"
                      ref="otpField"
                      v-model.trim="otpCode"
                      type="text"
                      maxlength="6"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      class="ui-input text-center otp-input"
                      :placeholder="$t('registration.otpPlaceholder')"
                      autocomplete="one-time-code"
                      :aria-invalid="Boolean(errors.otp)"
                      @keyup.enter="verifikasiOtp"
                    />
                    <p v-if="errors.otp" class="ui-error text-center">{{ errors.otp }}</p>
                  </div>

                  <div class="otp-resend mt-3">
                    <p v-if="hitungMundur > 0" class="text-muted small">
                      <i class="bi bi-hourglass-split me-1"></i>
                      {{ $t('registration.resendOtpIn', { n: hitungMundur }) }}
                    </p>
                    <button
                      v-else
                      type="button"
                      class="btn btn-link text-decoration-none btn-sm"
                      :disabled="mengirimOtp"
                      @click="mintaOtp"
                    >
                      <i class="bi bi-arrow-clockwise me-1"></i>
                      {{ $t('registration.resendOtp') }}
                    </button>
                  </div>
                </div>
              </transition>

              <div v-if="galatUmum" class="reg__alert" role="alert">
                <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
                <span>{{ galatUmum }}</span>
              </div>
            </div>

            <div class="reg-card__foot">
              <button
                v-if="isOtpStep"
                type="button"
                class="ui-btn ui-btn--ghost"
                :disabled="mengirim || mengirimOtp"
                @click="stepAktif = 0"
              >
                <i class="bi bi-pencil-square" aria-hidden="true"></i> {{ $t('registration.changeEmail') }}
              </button>
              <span v-else></span>

              <button type="submit" class="ui-btn ui-btn--primary ui-btn--lg" :disabled="mengirim || mengirimOtp">
                <span v-if="mengirim || mengirimOtp" class="ui-spinner" aria-hidden="true"></span>
                <template v-if="!isOtpStep">
                  {{ $t('registration.sendOtpButton') }} <i class="bi bi-shield-check" aria-hidden="true"></i>
                </template>
                <template v-else>
                  {{ mengirim ? $t('registration.verifyingOtp') : $t('registration.verifyAndFinish') }}
                </template>
              </button>
            </div>
          </form>

          <p class="reg__login">
            {{ $t('auth.hasAccount') }}
            <router-link to="/admin/login">{{ $t('auth.loginHere') }}</router-link>
          </p>
        </div>

        <!-- ══════════════ KOLOM SAMPING ══════════════ -->
        <aside class="reg__aside" v-reveal="'right'">
          <div v-if="tournament" class="ui-card reg-info">
            <SmartImage
              :source="tournament.image"
              :alt="tournament.name"
              :label="tournament.name"
              ratio="3 / 4"
            />
            <div class="ui-card__body">
              <h2 class="reg-info__title">{{ tournament.name }}</h2>
              <ul class="reg-info__meta">
                <li v-if="tournament.event_date">
                  <i class="bi bi-calendar-event" aria-hidden="true"></i>
                  <span>{{ tournament.event_date }}</span>
                </li>
                <li v-if="tournament.location">
                  <i class="bi bi-geo-alt" aria-hidden="true"></i>
                  <span>{{ tournament.location }}</span>
                </li>
                <li v-if="tournament.technical_meeting_date">
                  <i class="bi bi-people" aria-hidden="true"></i>
                  <span>
                    {{ $t('tournament.technicalMeeting') }}:
                    {{ tanggalPanjang(tournament.technical_meeting_date) }}
                  </span>
                </li>
                <li v-if="tournament.registration_deadline">
                  <i class="bi bi-hourglass-split" aria-hidden="true"></i>
                  <span>
                    {{ $t('tournament.registrationDeadline') }}:
                    {{ tanggalPanjang(tournament.registration_deadline) }}
                    <strong v-if="keteranganSisa"> — {{ keteranganSisa }}</strong>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div class="ui-card reg-help">
            <div class="ui-card__body">
              <h3 class="reg-help__title">
                <i class="bi bi-life-preserver" aria-hidden="true"></i> {{ $t('registration.needHelp') }}
              </h3>
              <ul class="reg-help__list">
                <li v-for="(t, i) in bantuan" :key="i">{{ $t(t) }}</li>
              </ul>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from 'vue-toastification';
import http, { setToken } from '@/services/http';
import SmartImage from '@/components/ui/SmartImage.vue';

export default {
  name: 'RegistrationPage',

  setup() {
    return { toast: useToast() };
  },

  components: { SmartImage },

  data() {
    return {
      stepAktif: 0,

      form: {
        person_responsible: '',
        email: '',
        password: '',
        password_confirmation: '',
      },

      otpCode: '',
      mengirimOtp: false,
      timerId: null,
      hitungMundur: 0,

      errors: {},
      galatUmum: '',
      lihatSandi: false,
      mengirim: false,

      tournament: null,
      kategori: [],
      terpilih: [],
      muatKategori: true,

      bantuan: ['registration.help1', 'registration.help2', 'registration.help3'],
    };
  },

  computed: {
    punyaAcara() {
      return Boolean(this.$route.params.slug);
    },

    isOtpStep() {
      return this.langkah[this.stepAktif]?.key === 'otp';
    },

    langkah() {
      return [
        { key: 'akun', label: 'registration.stepAccount' },
        { key: 'otp', label: 'registration.stepOtp' },
      ];
    },

    /** Hitung mundur pendaftaran, memakai angka yang dihitung server. */
    keteranganSisa() {
      const n = this.tournament?.sisa_hari_pendaftaran;
      if (n === null || n === undefined) return '';
      if (n < 0) return this.$t('tournament.deadlinePassed');
      if (n === 0) return this.$t('tournament.deadlineToday');
      return this.$t('tournament.deadlineLeft', { n });
    },

    kekuatanSandi() {
      const p = this.form.password;
      if (!p) return 0;
      let n = 0;
      if (p.length >= 8) n += 1;
      if (/[a-zA-Z]/.test(p) && /\d/.test(p)) n += 1;
      if (p.length >= 12 || /[^a-zA-Z0-9]/.test(p)) n += 1;
      return n;
    },

    labelKekuatan() {
      const kunci = ['', 'registration.strengthWeak', 'registration.strengthFair', 'registration.strengthStrong'];
      return this.kekuatanSandi ? this.$t(kunci[this.kekuatanSandi]) : '';
    },

    totalBiaya() {
      return this.kategori
        .filter((k) => this.terpilih.includes(k.id))
        .reduce((t, k) => t + Number(k.registration_fee || 0), 0);
    },
  },

  mounted() {
    document.title = this.$t('registration.eyebrow') || 'Pendaftaran Kontingen';
    this.muatTurnamen();
  },

  beforeUnmount() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },

  methods: {
    tanggalPanjang(nilai) {
      if (!nilai) return '';
      const d = new Date(nilai);
      if (Number.isNaN(d.getTime())) return nilai;
      return d.toLocaleDateString(this.$i18n.locale === 'en' ? 'en-GB' : 'id-ID', {
        weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
      });
    },

    rupiah(n) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        maximumFractionDigits: 0,
      }).format(Number(n) || 0);
    },

    async muatTurnamen() {
      const slug = this.$route.params.slug;
      if (!slug) { this.muatKategori = false; return; }

      try {
        const { data } = await http.get(`/tournaments/detail/${slug}`);
        this.tournament = data;
        this.kategori = Array.isArray(data?.categories) ? data.categories : [];
      } catch (e) {
        this.tournament = null;
        this.kategori = [];
      } finally {
        this.muatKategori = false;
      }
    },

    validasiAkun() {
      const e = {};
      const f = this.form;

      if (!f.person_responsible) e.person_responsible = this.$t('validation.nameRequired');
      if (!f.email) e.email = this.$t('validation.emailRequired');
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email)) e.email = this.$t('validation.email');

      if (!f.password) e.password = this.$t('validation.passwordRequired');
      else if (f.password.length < 8) e.password = this.$t('validation.passwordMin');
      else if (!(/[a-zA-Z]/.test(f.password) && /\d/.test(f.password)))
        e.password = this.$t('validation.passwordFormat');

      if (f.password !== f.password_confirmation)
        e.password_confirmation = this.$t('validation.passwordRepeatMismatch');

      this.errors = e;
      return Object.keys(e).length === 0;
    },

    mulaiTimer() {
      this.hitungMundur = 60;
      if (this.timerId) clearInterval(this.timerId);
      this.timerId = setInterval(() => {
        if (this.hitungMundur > 0) {
          this.hitungMundur--;
        } else {
          clearInterval(this.timerId);
        }
      }, 1000);
    },

    async mintaOtp() {
      if (!this.validasiAkun()) {
        this.stepAktif = 0;
        return;
      }

      this.mengirimOtp = true;
      this.galatUmum = '';
      const toast = useToast();

      try {
        const { data } = await http.post('/register/kirim-otp', {
          person_responsible: this.form.person_responsible,
          email: this.form.email,
          password: this.form.password,
          password_confirmation: this.form.password_confirmation,
        });

        toast.success(data.message || this.$t('registration.otpHint'));
        this.otpCode = '';
        this.mulaiTimer();

        // Pindah ke langkah OTP
        const otpIndex = this.langkah.findIndex((s) => s.key === 'otp');
        if (otpIndex !== -1) {
          this.stepAktif = otpIndex;
        }

        this.$nextTick(() => {
          if (this.$refs.otpField) {
            this.$refs.otpField.focus();
          }
        });
      } catch (err) {
        if (err.validationErrors) {
          this.errors = Object.fromEntries(
            Object.entries(err.validationErrors).map(([k, v]) => [k, Array.isArray(v) ? v[0] : v])
          );
          this.stepAktif = 0;
          this.galatUmum = this.$t('registration.checkFields');
        } else {
          this.galatUmum = err.friendlyMessage || err.message || this.$t('registration.failed');
          toast.error(this.galatUmum);
        }
      } finally {
        this.mengirimOtp = false;
      }
    },

    lanjut() {
      this.galatUmum = '';

      if (this.stepAktif === 0) {
        if (!this.validasiAkun()) return;
        this.mintaOtp();
        return;
      }

      if (this.isOtpStep) {
        this.verifikasiOtp();
      }
    },

    async verifikasiOtp() {
      this.errors = {};
      if (!this.otpCode || this.otpCode.length !== 6) {
        this.errors.otp = 'Masukkan 6 digit kode OTP.';
        return;
      }

      this.mengirim = true;
      this.galatUmum = '';
      const toast = useToast();

      try {
        const { data } = await http.post('/register/verifikasi-otp', {
          person_responsible: this.form.person_responsible,
          email: this.form.email,
          password: this.form.password,
          password_confirmation: this.form.password_confirmation,
          otp: this.otpCode,
        });

        setToken(data.access_token);
        localStorage.setItem('user', JSON.stringify(data.user));
        this.$store.dispatch('setAuthToken', data.access_token);
        this.$store.dispatch('setUser', data.user);

        if (this.timerId) clearInterval(this.timerId);

        toast.success(this.$t('registration.success'));
        this.$router.push('/admin');
      } catch (err) {
        if (err.validationErrors) {
          this.errors = Object.fromEntries(
            Object.entries(err.validationErrors).map(([k, v]) => [k, Array.isArray(v) ? v[0] : v])
          );
        } else {
          this.errors.otp = err.friendlyMessage || err.message || 'Kode OTP salah atau kedaluwarsa.';
          toast.error(this.errors.otp);
        }
      } finally {
        this.mengirim = false;
      }
    },
  },
};
</script>

<style scoped>
.reg__head { text-align: center; margin-bottom: var(--space-6); }

@media (min-width: 768px) { .reg__head { margin-bottom: var(--space-10); } }

.reg__title {
  font-size: clamp(1.35rem, 6.5vw, var(--text-5xl));
  margin-bottom: var(--space-3);
  overflow-wrap: anywhere;
}

.reg__tournament {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  margin: 0;
  padding: var(--space-2) var(--space-4);
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--text-brand);
  background: var(--accent-subtle);
  border-radius: var(--radius-full);
}

.reg__layout { display: grid; grid-template-columns: 1fr; gap: var(--space-6); align-items: start; }

/*
 * Di ponsel, ringkasan turnamen dipindah ke ATAS formulir.
 * Pengguna perlu memastikan sedang mendaftar ke turnamen yang benar sebelum
 * mulai mengetik; menaruhnya di bawah formulir panjang berarti informasi itu
 * baru terlihat setelah semuanya selesai diisi.
 */
.reg__aside { order: -1; }

/*
 * Di ponsel, poster di kartu ringkasan hanya perlu cukup besar untuk dikenali
 * — bukan dibaca. Dibiarkan selebar kartu, ia mendorong seluruh formulir
 * pendaftaran keluar dari layar pertama.
 */
@media (max-width: 991px) {
  .reg-info :deep(.smart-img) {
    max-width: 180px;
    margin-inline: auto;
  }
}

@media (max-width: 400px) {
  .reg-info :deep(.smart-img) { max-width: 140px; }
}
.reg__main  { order: 0; }

@media (min-width: 992px) {
  .reg__layout { grid-template-columns: 1.5fr 1fr; gap: var(--space-10); }
  .reg__aside { order: 0; }
}

/* ── Penunjuk langkah ── */
.stepper { display: flex; align-items: center; gap: var(--space-2); list-style: none; margin: 0 0 var(--space-6); padding: 0; }

.stepper__item {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex: 1;
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--text-muted);
}

.stepper__item + .stepper__item::before {
  content: '';
  flex: 1;
  height: 2px;
  background: var(--border-subtle);
  border-radius: var(--radius-full);
  transition: background var(--transition-base);
}

.stepper__item.is-active, .stepper__item.is-done { color: var(--text-primary); }
.stepper__item.is-active::before, .stepper__item.is-done::before { background: var(--grad-flame-soft); }

.stepper__dot {
  display: grid;
  place-items: center;
  width: 30px; height: 30px;
  font-size: var(--text-xs);
  font-weight: 700;
  color: var(--text-muted);
  background: var(--bg-sunken);
  border: 2px solid var(--border-subtle);
  border-radius: 50%;
  flex-shrink: 0;
  transition: all var(--transition-base);
}

.stepper__item.is-active .stepper__dot {
  color: #fff;
  background: var(--grad-flame-soft);
  border-color: transparent;
  box-shadow: 0 0 0 4px var(--accent-subtle);
}

.stepper__item.is-done .stepper__dot { color: #fff; background: var(--success-500); border-color: transparent; }

.stepper__label { white-space: nowrap; }
@media (max-width: 480px) { .stepper__label { display: none; } }

/* ── Kartu formulir ── */
.reg-card__body { padding: var(--space-8); }
@media (max-width: 640px) { .reg-card__body { padding: var(--space-5); } }

.reg-card__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-5);
  border-top: 1px solid var(--border-subtle);
  background: var(--bg-sunken);
}

/* Di layar sempit tombol "Lanjut" dibuat selebar kartu supaya jelas ini
   tindakan utamanya, dan "Kembali" tetap di sebelah kiri. */
@media (max-width: 480px) {
  .reg-card__foot { flex-direction: column-reverse; align-items: stretch; }
  .reg-card__foot .ui-btn { width: 100%; }
}

@media (min-width: 640px) { .reg-card__foot { padding: var(--space-5) var(--space-8); } }



.step-pane { display: flex; flex-direction: column; gap: var(--space-5); }
.step-pane__title { font-size: var(--text-xl); margin: 0; }
.step-pane__hint { margin: calc(var(--space-4) * -1) 0 0; font-size: var(--text-sm); color: var(--text-secondary); }

.reg__two-col { display: grid; grid-template-columns: 1fr; gap: var(--space-5); }
@media (min-width: 640px) { .reg__two-col { grid-template-columns: 1fr 1fr; } }

.reg__pw { position: relative; }
.reg__pw .ui-input { padding-right: 3rem; }

.reg__pw-toggle {
  position: absolute;
  right: 4px; top: 50%;
  transform: translateY(-50%);
  display: grid; place-items: center;
  width: 40px; height: 40px;
  min-width: 40px; min-height: 40px;
  color: var(--text-muted);
  background: transparent;
  border: none; border-radius: var(--radius-sm);
  cursor: pointer;
  transition: color var(--transition-fast);
}

.reg__pw-toggle:hover { color: var(--text-primary); }

.pw-meter { display: flex; align-items: center; gap: 5px; }

.pw-meter__bar {
  height: 4px; flex: 1; max-width: 44px;
  background: var(--border-subtle);
  border-radius: var(--radius-full);
  transition: background-color var(--transition-base);
}

.pw-meter__bar.is-on[data-level='1'] { background: var(--danger-500); }
.pw-meter__bar.is-on[data-level='2'] { background: var(--gold-500); }
.pw-meter__bar.is-on[data-level='3'] { background: var(--success-500); }

.pw-meter__label { margin-left: var(--space-2); font-size: var(--text-xs); font-weight: 600; color: var(--text-muted); }

/* ── Pilihan kategori ── */
.kategori-grid { display: grid; grid-template-columns: 1fr; gap: var(--space-3); }
@media (min-width: 560px) { .kategori-grid { grid-template-columns: 1fr 1fr; } }

.kategori {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: 60px;
  padding: var(--space-3) var(--space-4);
  background: var(--bg-surface);
  border: 2px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: border-color var(--transition-fast), background-color var(--transition-fast),
              transform var(--transition-fast);
}

.kategori:hover { border-color: var(--border-strong); transform: translateY(-2px); }
.kategori.is-picked { border-color: var(--accent); background: var(--accent-subtle); }

.kategori__check {
  display: grid;
  place-items: center;
  width: 24px; height: 24px;
  font-size: 0.75rem;
  color: transparent;
  background: var(--bg-sunken);
  border: 2px solid var(--border-strong);
  border-radius: var(--radius-sm);
  flex-shrink: 0;
  transition: all var(--transition-fast);
}

.kategori.is-picked .kategori__check { color: #fff; background: var(--accent); border-color: var(--accent); }

/* Kotak centang asli disembunyikan, jadi cincin fokus dipindahkan ke
   penanda visual supaya navigasi keyboard tetap terlihat. */
.kategori input:focus-visible + .kategori__check { outline: 2px solid var(--accent); outline-offset: 2px; }

.kategori__body { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.kategori__name { font-weight: 700; font-size: var(--text-sm); color: var(--text-primary); }
.kategori__fee { font-size: var(--text-xs); color: var(--text-secondary); }
.kategori__fee small { opacity: 0.75; }

/* ── Ringkasan biaya ── */
.biaya { padding: var(--space-5); background: var(--bg-sunken); border: 1px solid var(--border-subtle); border-radius: var(--radius-lg); }

.biaya__row {
  display: flex; align-items: center; justify-content: space-between;
  gap: var(--space-3); font-size: var(--text-sm); color: var(--text-secondary);
}

.biaya__row + .biaya__row { margin-top: var(--space-2); }

.biaya__row--total {
  padding-top: var(--space-3);
  margin-top: var(--space-3);
  border-top: 1px solid var(--border-subtle);
  font-size: var(--text-base);
}

.biaya__row--total strong { font-size: var(--text-xl); font-weight: 800; }
.biaya__note { margin: var(--space-3) 0 0; font-size: var(--text-xs); color: var(--text-muted); line-height: 1.5; }

/* ── Galat & tautan ── */
.reg__alert {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  margin-top: var(--space-5);
  padding: var(--space-3) var(--space-4);
  font-size: var(--text-sm);
  color: var(--danger-500);
  background: rgb(220 38 38 / 0.1);
  border: 1px solid rgb(220 38 38 / 0.24);
  border-radius: var(--radius-md);
}

.reg__login { margin: var(--space-5) 0 0; text-align: center; font-size: var(--text-sm); color: var(--text-secondary); }

/* ── Kolom samping ── */
.reg__aside {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  position: sticky;
  top: calc(var(--header-height) + var(--space-5));
}

@media (max-width: 991px) { .reg__aside { position: static; } }

.reg-info__title { font-size: var(--text-lg); margin-bottom: var(--space-4); }
.reg-info__meta { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: var(--space-2); }

.reg-info__meta li {
  display: flex; align-items: flex-start; gap: var(--space-3);
  font-size: var(--text-sm); color: var(--text-secondary);
}

.reg-info__meta i { color: var(--accent); margin-top: 2px; }

.reg-help__title { display: flex; align-items: center; gap: var(--space-2); font-size: var(--text-base); margin-bottom: var(--space-3); }
.reg-help__title i { color: var(--gold); }

/* ── OTP Verifikasi ── */
.otp-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: var(--radius-full);
  background: rgb(220 38 38 / 0.12);
  margin-inline: auto;
}

.otp-email-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  margin-top: var(--space-2);
  padding: var(--space-1) var(--space-3);
  font-size: var(--text-sm);
  background: var(--bg-sunken);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-full);
  color: var(--text-primary);
}

.otp-input {
  font-family: monospace;
  font-size: 1.85rem;
  letter-spacing: 0.35em;
  font-weight: 700;
  text-align: center;
  padding-block: var(--space-3);
}

/* ── Transisi langkah ── */
.step-enter-active { transition: opacity 280ms var(--ease-out-quart), transform 280ms var(--ease-out-quart); }
.step-leave-active { transition: opacity 160ms var(--ease-out-quart), transform 160ms var(--ease-out-quart); }
.step-enter-from { opacity: 0; transform: translateX(18px); }
.step-leave-to   { opacity: 0; transform: translateX(-14px); }
</style>
